import dayjs from 'dayjs';
import advancedFormat from 'dayjs/plugin/advancedFormat';

export const formatDate = (date: number) => dayjs(date).format('MMMM D, YYYY h:mm A');

export const formatTime = (time: string) => {
  const timeArray = time.split(':');
  const hour = timeArray[0];
  const minute = timeArray[1];
  const second = timeArray[2];
  const date = new Date();

  date.setHours(parseInt(hour, 10));
  date.setMinutes(parseInt(minute, 10));
  date.setSeconds(parseInt(second, 10));

  const formattedTime = dayjs(date).format('hh:mm A');
  return formattedTime;
};

export const parseDate = (time: string) => {
  const timeArray = time.split(':');
  const hour = timeArray[0];
  const minute = timeArray[1];
  const second = timeArray[2];
  const date = new Date();

  date.setHours(parseInt(hour, 10));
  date.setMinutes(parseInt(minute, 10));
  date.setSeconds(parseInt(second, 10));
  return date;
};

export const convertTimeStamps = (time: number) => dayjs.unix(time);

export const advanceFormatDate = (time: number) => {
  dayjs.extend(advancedFormat);
  return convertTimeStamps(time).format(`${'Do MMM’YY, hh:mm A'}`);
};

export const convertHoursMinutesToSeconds = (time: string, nextDay?: number) => {
  const currentDate = nextDay
    ? dayjs().add(nextDay, 'day').format('YYYY-MM-DD')
    : dayjs().format('YYYY-MM-DD');
  return dayjs(`${currentDate} ${time}`).valueOf();
};
